module.exports = __webpack_public_path__ + "img/c++.2de96900.png";